//Provider para Palestrantes
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Jsonp, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'

//Providers
import { ConfigProvider } from './config-provider';
import { UtilProvider } from './util-provider';

//Models
import { Url } from '../models/url.model';
import { Expositor } from '../models/expositor/expositor.model';
import { ExpositoresPorTipo } from '../models/expositor/expositores-tipo.model';

@Injectable()
export class ExpositorProvider {

    public headers: Headers;
    public options: RequestOptions;
    public url = new Url;
    public params = new URLSearchParams();


    constructor(
        public http: Http,
        public jsonp: Jsonp,
        public configProvider: ConfigProvider,
        public utilProvider: UtilProvider) {
        this.url = configProvider.url;
        this.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': this.url.SgunAuthorization, 'MobileReferer': this.url.SgunReferer });
        this.options = new RequestOptions({ headers: this.headers });

        this.params.set('format', 'json');
        this.params.set('callback', this.configProvider.CALLBACK);
    }

    getExpositores(congressoAno: number, basicInfo: boolean, detaque: boolean): Promise<Array<Expositor>> {
        let param = this.params;
        param.set('congressoAno', <any>congressoAno);
        param.set('basicInfo', <any>basicInfo);
        param.set('detaque', <any>detaque);
        return this.jsonp.get(this.url.Cientifico + '/shared/apc/getExpositores.ashx', { search: param })
            .map(res => res.json()).toPromise()
            .then(data => {

                if (data && data.resposta.codigo == 0)
                    return data.resposta.retorno as Array<Expositor>;
            });
    }

    getExpositoresGroupedByType(congressoAno: number, basicInfo: boolean, detaque: boolean): Promise<Array<ExpositoresPorTipo>> {
        let param = this.params;
        param.set('congressoAno', <any>congressoAno);
        param.set('basicInfo', <any>basicInfo);
        param.set('detaque', <any>detaque);
        return this.jsonp.get(this.url.Cientifico + '/shared/apc/getExpositoresGroupedByType.ashx', { search: param })
            .map(res => res.json()).toPromise()
            .then(data => {

                if (data && data.resposta.codigo == 0)
                    return data.resposta.retorno as Array<ExpositoresPorTipo>;
            });
    }

    getExpositorById(id: number, basicInfo: boolean, userGuid: string): Promise<Expositor> {

        let param = this.params;
        param.set('id', <any>id);
        param.set('basicInfo', <any>basicInfo);
        param.set('userGuid', <any>userGuid);
        return this.jsonp.get(this.url.Cientifico + `/shared/apc/getExpositorById.ashx?`, { search: param })
            .map(res => res.json()).toPromise()
            .then(data => {
                if (data && data.resposta.codigo == 0)
                    return data.resposta.retorno as Expositor;

            });
    }
}



// WEBPACK FOOTER //
// ./src/providers/expositor-provider.ts